<router-outlet></router-outlet><bh-spinner></bh-spinner
 >


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/layout/layout.component.ts.LayoutComponent.html